<template>
  <b-navbar-nav>
    <component :key="index" v-for="(child,index) in items" :blok="child" :is="child.component"></component>
  </b-navbar-nav>
</template>
<script>
import NavigationItem from "./NavigationItem.vue";
import NavigationGroup from "./NavigationGroup.vue";
import ShopifyCheckoutButton from '../shopify/ShopifyCheckoutButton';
import BasketButton from '../basket/BasketButton';
import MobileBasketButton from '../basket/MobileBasketButton';

export default {
  name: "navigation",
  props: {
      items: Array
  },
  components: {
    'navigation-item-list': NavigationGroup,
    'navigation-item': NavigationItem,
    'shopify-checkout-button': ShopifyCheckoutButton
  }
};
</script>